
<template lang="pug">
v-container(mb-2="")
  v-img(src="../assets/SOS_white_wordmark.png" max-height="100" contain)
  h1 Say "NO" to the curriculum
  v-stepper(v-model="e1", mb-2="")
    v-stepper-header
      v-stepper-step(step="1", :complete="e1 > 1") Your Information
      v-divider
      v-stepper-step(step="2", :complete="e1 > 2") Compose Letter
      v-divider
      v-stepper-step(step="3", :complete="e1 > 3") Confirm Email
    v-stepper-items
      v-stepper-content(step="1")
        v-form
          p
            | Elected officials need to know that your email is coming from a real, concerned citizen.
          p
            | Please provide accurate information about yourself so they can respond to you. Your name, email and postal code will be included in the email that is sent.
          v-text-field(
            label="First Name *",
            v-model="first_name",
            name="first_name",
            v-validate="'required'",
            :error-messages="errors.collect('first name')",
            required="",
            data-vv-name="first name",
            type="text"
          )
          v-text-field(
            label="Last Name *",
            v-model="last_name",
            v-validate="'required'",
            :error-messages="errors.collect('last name')",
            data-vv-name="last name",
            name="last_name",
            required="",
            type="text"
          )
          v-text-field(
            label="Email *",
            v-model="email",
            v-validate="'required|email'",
            :error-messages="errors.collect('email')",
            data-vv-name="email",
            required="",
            name="email",
            type="email"
          )
          v-text-field(
            label="Postal Code *",
            v-model="postal_code",
            v-validate!="{ required: true, regex:/\\s*[a-zA-Z]\\d[a-zA-Z]\\s*\\d[a-zA-Z]\\d\\s*/}",
            data-vv-name="postal code",
            :error-messages="errors.collect('postal code')",
            name="postal_code",
            required="",
            type="text"
          )
        v-btn(
          :disabled="errors.any()",
          color="primary",
          @click="move_to_compose_letter"
        ) Next
      v-stepper-content(step="2" fluid="")
        v-row
          v-col
            span Use our letter builder to select and build a letter from our templates, or edit yourself to enter your own text.
        v-container(v-if="loading", justify="center", align="center")
          v-row(justify="center")
            v-progress-circular(color="light-blue", indeterminate)
        v-container(v-else)
          v-row(no-gutters="", align="center")
            v-col(fluid)
              paragraph-composer(
                label="Subject",
                v-on:input="subject = arguments[0]",
                :stub_values="subject_stubs"
              )
          v-row
            v-col
              span To: {{ recipient_names }} &nbsp;
              p.ma-0.pa-0(v-if="mla_name") cc: {{ mla_name }}, Support Our Students
                span(v-for="cc in cc_recipients") , {{ cc.name }}
              p.ma-0.pa-0(v-for="att in attachments") Attachment:
                v-icon attach_file
                a(:href="att.url", target="_blank") {{ att.name }}
          // Delay adding to the DOM unless this stepper is shown because the auto-grow height of the textareas can't be calculated unless visible
          v-row(v-for="(item, index) in paragraph_stubs", :key="index")
            v-col
              v-lazy
                paragraph-composer(
                  v-on:input="paragraphs[index] = arguments[0]",
                  :stub_values="paragraph_stubs[index]"
                )
          v-row
            v-col
              p Sincerely,
              p {{ first_name }} {{ last_name }}
                br
                | {{ email }}
                br
                | {{ postal_code }}
          v-row
            v-btn(@click="e1 = 1") Back
            v-btn(color="primary", @click="submit_letter") Next
      v-stepper-content(step="3")
        v-container(v-if="loading", justify="center", align="center")
          v-row(justify="center")
            v-progress-circular(color="light-blue", indeterminate)
        v-container.pa-2(v-else, fluid)
          v-row
            v-col
              v-alert(type="info", prominent="") 
                h2 Check your email and click on the confirmation link to complete.
                h4 If you don't receive the email within 2 minutes, check your junk folder
              h3 In the meantime, here&apos;s some other ways to take action:
          v-row
            v-col
              // Force this to re-render when the visibility of the stepper content changes so that the 
              // text boxs shows the correct size
              twitter-composer(:key="e1", :stub_values="twitter_stubs")
          v-row
            v-col
              facebook-composer(
                :facebookStub="facebook_stub",
                :facebookRedirect="facebook_redirect"
              )
          v-row.justify-center
            v-btn(
              href="https://www.studentsdeservebetter.ca",
              target="_parent"
            ) More Ideas...
</template>

<script>
import ParagraphComposer from "./ParagraphComposer";
import FacebookComposer from "./FacebookComposer";
import TwitterComposer from "./TwitterComposer";
import axios from "axios";
export default {
  components: {
    "paragraph-composer": ParagraphComposer,
    "facebook-composer": FacebookComposer,
    "twitter-composer": TwitterComposer,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      wholeResponse: [],
      riding_lookedup: false,
      twitter_stubs: [],
      facebook_stub: "",
      facebook_redirect: "",
      tweet_content: "",
      first_name: "",
      postal_code: "",
      last_name: "",
      email: "",
      recipients: [],
      cc_recipients: [],
      mla_name: "",
      mla_email: "",
      paragraphs: [[""], [""], [""],[""],[""]],
      attachments: [],
      paragraph_stubs: [[""], [""], [""]],
      subject: "",
      subject_stubs: [""],
      is_email_subscribed: false,
      e1: 1,
      campaignId: "",
      loading: false,
      dummyKey: false
    };
  },
  computed: {
    recipient_names() {
      return this.recipients.map((x) => x.name).join(", ");
    },
    signature_block() {
      return `${this.first_name} ${this.last_name}
${this.email}
${this.postal_code}`;
    },
  },
  mounted() {
    this.apiUrl = process.env.VUE_APP_API_URL;
    this.campaignId = "4644de1f-788d-4b7d-a397-23f93acd8f8a";
    this.load_template();
  },
  methods: {
    submit_letter() {
      this.loading = true;
      axios
        .post(
          this.apiUrl +
            "/v1/campaign/" +
            this.campaignId +
            "/letter_submissions",
          {
            recipients: this.recipients.map((x) => x.email),
            cc_recipients: [this.mla_email],
            subject: this.subject,
            paragraphs: this.paragraphs,
            sender_email: this.email,
            sender_firstname: this.first_name,
            sender_lastname: this.last_name,
            sender_postalcode: this.postal_code,
            campaign_id: this.campaignId,
          }
        )
        .then(() => {
          this.loading = false;
          this.e1 = 3;
        });
    },
    getMla() {
      axios
        .get(this.apiUrl + "/v1/ridings", {
          params: {
            postal_code: this.postal_code,
          },
          timeout: 8000,
        })
        .then((response) => {
          if (response) {
            this.mla_name =
              response.data.title +
              " " +
              response.data.first_name +
              " " +
              response.data.last_name +
              ", " +
              response.data.riding_name;
            this.mla_email = response.data.email;
          }
        })
        .catch(function () {
          return false;
        });
    },
    move_to_compose_letter() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          this.getMla();
          this.e1 = 2;
          this.loading = false;
          this.$nextTick(() => {
            this.$forceUpdate();
            this.dummyKey = !this.dummyKey;
          });
        }
      });
    },
    load_template() {
      axios
        .get(
          this.apiUrl +
            "/v1/campaign/" +
            this.campaignId +
            "/letter_templates",
          { timeout: 8000 }
        )
        .then((response) => {
          this.subject_stubs = response.data.subject_stubs;
          this.recipients = response.data.recipients;
          this.twitter_stubs = response.data.twitter_stubs;
          this.paragraph_stubs= response.data.paragraph_stubs;
          this.facebook_stub = response.data.facebook_stub;
          this.facebook_redirect = response.data.facebook_redirect;
          this.attachments = response.data.attachments;
          this.cc_recipients = response.data.cc_recipients;
        })
        .catch(() => {
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
